import { TrustLabelPeriod } from '../../../../../components-library/labels/TrustLabel';

export default {
  labels: {
    [TrustLabelPeriod.LESS_THAN_1_MONTH]: 'Oltre +100 clienti hanno già ordinato in sicurezza da noi',
    [TrustLabelPeriod.ONE_MONTH_OR_MORE]: 'Oltre +1.000 clienti hanno già ordinato in sicurezza da noi',
    [TrustLabelPeriod.SIX_MONTHS_OR_MORE]: 'Oltre +10.000 clienti hanno già ordinato in sicurezza da noi',
  },
};
